export const API_URL = "/api";



 //export const API_URL = "http://10.252.216.10:5000/api";
